import { useMutation } from "react-query";
import { reactQueryDelete } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface DeleteConversationOptions {
  onError?: (error: unknown) => void;
  onSuccess?: () => void;
}

interface DeleteConversationParams {
  conversationId: string;
}

export const useDeleteConversation = ({
  onSuccess,
  onError,
}: DeleteConversationOptions = {}) =>
  useMutation({
    mutationFn: async ({ conversationId }: DeleteConversationParams) =>
      reactQueryDelete(
        internalApi.helpWidget.deleteConversation({ conversationId }),
      ),
    onSuccess,
    onError,
  });
